export default function InfrastructureOverviewSection() {
  return (
    <section id="infrastructure" className="relative py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="max-w-3xl mb-12">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-white rounded-md border border-slate-200 mb-6">
            <i className="ri-building-line text-slate-600 text-sm"></i>
            <span className="text-slate-600 text-sm font-medium tracking-wide">基礎建設與市場結構</span>
          </div>

          <h2 className="text-4xl lg:text-5xl font-black text-slate-900 leading-tight mb-6">
            港口升級與人流結構轉變
            <span className="block mt-2 text-slate-600">餐飲市場的關鍵支撐</span>
          </h2>
        </div>

        {/* Main Grid */}
        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          {/* Left: Port as Gateway */}
          <div className="bg-white rounded-lg overflow-hidden border border-slate-200 shadow-lg">
            <div className="relative h-64">
              <img
                src="https://public.readdy.ai/ai/img_res/21bfa50c3a71a7a620143dfe18139e30.jpg"
                alt="金門小三通新碼頭"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <h3 className="text-xl font-black text-white mb-1">碼頭＝消費入口</h3>
                <p className="text-slate-200 text-sm">人流集中、分流並向市區擴散，餐飲成為第一接觸型消費</p>
              </div>
            </div>
            <div className="p-6">
              <div className="grid grid-cols-3 gap-4 text-center">
                <div>
                  <div className="text-xl font-black text-slate-900 kpi-range">40–60%</div>
                  <div className="text-xs text-slate-600">候船區轉換率</div>
                </div>
                <div>
                  <div className="text-xl font-black text-slate-900">團散混合</div>
                  <div className="text-xs text-slate-600">客群結構</div>
                </div>
                <div>
                  <div className="text-xl font-black text-slate-900">高翻桌</div>
                  <div className="text-xs text-slate-600">營運模型</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Tourism Trend */}
          <div className="bg-white rounded-lg overflow-hidden border border-slate-200 shadow-lg">
            <div className="relative h-64">
              <img
                src="https://readdy.ai/api/search-image?query=kinmen%20port%20terminal%20passengers%20walking%20with%20luggage%20modern%20infrastructure%20clean%20professional%20photography%20showing%20tourist%20flow&width=800&height=400&seq=infra-002&orientation=landscape"
                alt="金門碼頭旅客"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <h3 className="text-xl font-black text-white mb-1">消費型人流成形</h3>
                <p className="text-slate-200 text-sm">短天數、高消費型旅客比例提高，餐飲支出佔比上升</p>
              </div>
            </div>
            <div className="p-6">
              <div className="grid grid-cols-3 gap-4 text-center">
                <div>
                  <div className="text-xl font-black text-slate-900">3.2天</div>
                  <div className="text-xs text-slate-600">平均停留</div>
                </div>
                <div>
                  <div className="text-xl font-black text-slate-900">35%</div>
                  <div className="text-xs text-slate-600">餐飲支出佔比</div>
                </div>
                <div>
                  <div className="text-xl font-black text-slate-900">+127%</div>
                  <div className="text-xs text-slate-600">年度成長率</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Aviation Support - 簡化為概括描述 */}
        <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg p-8 border border-amber-200">
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-500 rounded-md">
              <i className="ri-plane-line text-white text-xl"></i>
            </div>
            <h3 className="text-xl font-black text-slate-900">海空雙軸並進，支撐全年穩定營運</h3>
          </div>
          
          <p className="text-slate-600 text-sm leading-relaxed">
            國內航空系統提供高密度航班服務，覆蓋台北、台中、高雄等主要城市，航班密度提供全年人流底盤，有效提升平日營收穩定度約<strong className="text-amber-700">+40%</strong>。
          </p>
        </div>
      </div>
    </section>
  );
}
